import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useFVPackage } from '../hooks/FVPackage/useFVPackage';
import useFetch from 'hooks/useFetch';
import Styled from '../styles/FVPackage.styled';
import StyledUnit from '../styles/FVPackageUnit.styled';
import { IFVPackage } from '../interfaces/FVPackage.interface';
import { bucketS3, caminhoAnexosFerramentaVideo } from 'constants/EnvironmentData';
import Colors from 'enums/Colors';
import { IoReturnUpBackOutline } from 'react-icons/io5';
import { Divider } from 'antd';
import FormFVUnit from '../components/FormFVUnit';
import { IFVPackageUnit } from '../interfaces/FVPackageUnit.interface';
import { useFVPackageUnit } from '../hooks/FVPackageUnit/useFVPackageUnit';
import { ToastError, ToastSuccess } from 'components/Toaster';
import FVActionButtons from '../components/FVActionsButton';
import MenuTypePackages from '../components/MenuTypePackages';
import { formatTitleWithIndexSizeFontAll, formatTitleWithPrefixIndex } from '../helpers/FormatTitleStyleHelper';
import { useFetchFVContainer } from '../hooks/FVContainer/useFetchFVContainer';

const AdminFVPackage = () => {
    const history = useHistory();
    const { idContainer, idPackage } = useParams<{ idContainer: string; idPackage: string }>();

    const [hoveredIndexCard, setHoveredIndexCard] = useState<number | null>(null);
    const { useUniqueFerramentaVideo } = useFetchFVContainer();
    const { data: containerData, isLoading } = useUniqueFerramentaVideo(Number(idContainer));

    const [formVisible, setFormVisible] = useState(false);

    const [form, setForm] = useState<IFVPackageUnit>({
        id: -1,
        title: '',
        nomenclature: '',
        description: '',
        url: '',
        altUrl: '',
        ordem: 0,
    });

    const resetForm = () => {
        setForm({
            id: -1,
            title: '',
            nomenclature: '',
            description: '',
            url: '',
            altUrl: '',
            ordem: 0,
        });
    };

    const [loading, setLoading] = useState<boolean>(false);

    const [packageData, setPackageData] = useState<IFVPackage | null>(null);

    const [listPackageUnits, setListPackageUnits] = useState<IFVPackageUnit[]>([]);

    const {
        listQuery: response,
        createPackageUnitMutation,
        updatePackageUnitMutation,
        deletePackageUnitMutation,
    } = useFVPackageUnit(idPackage ? Number(idPackage) : -1);

    const { fetchPackageById } = useFVPackage();

    const handleSubmit = async (e: React.FormEvent<Element>) => {
        e.preventDefault();

        setLoading(true);

        try {
            if (form.id === -1) {
                await createPackageUnitMutation.mutateAsync(form, {
                    onSuccess: () => {
                        ToastSuccess('Unidade de pacote criada com sucesso');
                        setForm({
                            id: -1,
                            title: '',
                            nomenclature: '',
                            description: '',
                            url: '',
                            altUrl: '',
                            ordem: 0,
                        });
                        setFormVisible(false);
                    },
                    onError: () => {
                        setForm({
                            id: -1,
                            title: '',
                            nomenclature: '',
                            description: '',
                            url: '',
                            altUrl: '',
                            ordem: 0,
                        });
                        ToastError('Erro ao atualizar unidade de pacote, verifique as informações e tente novamente.');
                        setLoading(false);
                        setFormVisible(false);
                    },
                });
            } else {
                await updatePackageUnitMutation.mutateAsync(form, {
                    onSuccess: () => {
                        ToastSuccess('Unidade de pacote atualizada com sucesso');
                        setForm({
                            id: -1,
                            title: '',
                            nomenclature: '',
                            description: '',
                            url: '',
                            altUrl: '',
                            ordem: 0,
                        });
                        setFormVisible(false);
                        setLoading(false);
                    },
                    onError: () => {
                        setForm({
                            id: -1,
                            title: '',
                            nomenclature: '',
                            description: '',
                            url: '',
                            altUrl: '',
                            ordem: 0,
                        });
                        ToastError('Erro ao atualizar unidade de pacote, verifique as informações e tente novamente.');
                        setLoading(false);
                        setFormVisible(false);
                    },
                });
            }
        } catch (error) {
            console.error('Erro ao salvar unidade de pacote:', error);
        } finally {
            setLoading(false);
        }
    };

    const deletePackageUnit = async (id: number) => {
        const status = await deletePackageUnitMutation.mutateAsync(id);

        if (Number(status) === 204) {
            // Handle successful deletion (e.g., show a success message)
            ToastSuccess('Unidade de pacote deletada com sucesso');
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setForm((prev: any) => ({ ...prev, [name]: value }));
    };

    useFetch(async () => {
        if (idPackage) {
            const packageData = await fetchPackageById(Number(idPackage));
            setPackageData(packageData);
        }
    }, [idPackage]);

    const fetchStorageFerramentaVideo = () => {
        return bucketS3() + caminhoAnexosFerramentaVideo();
    };

    const goToPackage = (id: number) => {
        history.push(`/admin/ferramenta-video/${id}`);
    };

    const goToContents = (idUnit: number) => {
        history.push(`/admin/ferramenta-video/${idContainer}/${idPackage}/${idUnit}`);
    };

    const handleEditForm = (unidade: IFVPackageUnit) => {
        setForm({
            id: unidade.id,
            title: unidade.title,
            nomenclature: unidade.nomenclature,
            description: unidade.description,
            url: unidade.url,
            altUrl: unidade.altUrl,
            ordem: unidade.ordem,
        });
        setFormVisible(true);
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        if (response.data) {
            setListPackageUnits(response.data);
        }
    }, [response.data]);

    return (
        <Styled.Page.Container>
            <MenuTypePackages hidden={containerData?.notAccessibility ?? false} />
            <FormFVUnit
                formVisible={formVisible}
                handleSubmit={handleSubmit}
                setForm={setForm}
                setFormVisible={(value: React.SetStateAction<boolean>) => {
                    setFormVisible(value);
                    resetForm();
                }}
                form={form}
                handleChange={handleChange}
                loading={loading}
            />
            <Styled.Button style={{ width: 'fit-content', padding: '8px 12px' }} onClick={() => goToPackage(Number(idContainer))}>
                <IoReturnUpBackOutline size={22} /> Voltar
            </Styled.Button>
            {packageData && (
                <>
                    <Styled.Page.Row>
                        <Styled.Page.Column>
                            <Styled.Page.SubTitle>
                                {packageData.nomenclature} {packageData.ordem}
                            </Styled.Page.SubTitle>
                            <Styled.Page.Title>{packageData.title}</Styled.Page.Title>
                            <Styled.Page.Description dangerouslySetInnerHTML={{ __html: packageData.description }} />
                        </Styled.Page.Column>

                        <Styled.Page.Card.Container>
                            <Styled.Page.Card.Content img={fetchStorageFerramentaVideo() + packageData.capaFilepath} />
                            <Styled.Page.Card.Content backcolor={Colors.Yellow}>
                                <h2>{packageData.nomenclature}</h2>
                                <h1>{packageData.ordem}</h1>
                            </Styled.Page.Card.Content>
                        </Styled.Page.Card.Container>
                    </Styled.Page.Row>
                    <Divider style={{ backgroundColor: '#f0f0f0', margin: '16px 0' }} />
                    <Styled.Button
                        style={{ width: 'fit-content', padding: '8px 12px' }}
                        onClick={() => {
                            setFormVisible(true);
                            window.scrollTo(0, 0);
                        }}
                    >
                        {packageData.nomenclature ? `Criar uma nova ${packageData.nomenclature}` : 'Criar uma nova unidade'}
                    </Styled.Button>
                    <Styled.Page.ContentGrid>
                        {listPackageUnits
                            ?.sort((a, b) => a.ordem - b.ordem)
                            .map((unidade, index) => {
                                return (
                                    <React.Fragment key={unidade.id}>
                                        <div>
                                            <StyledUnit.CardUnit.Container
                                                onMouseEnter={() => setHoveredIndexCard(index)}
                                                onMouseLeave={() => setHoveredIndexCard(null)}
                                                onClick={() => goToContents(unidade.id)}
                                            >
                                                <StyledUnit.CardUnit.Content
                                                    backcolor={hoveredIndexCard === index ? Colors.Yellow : Colors.White}
                                                >
                                                    <h2>{unidade?.nomenclature ?? 'unidade'}</h2>
                                                    <h1>{index + 1}</h1>
                                                </StyledUnit.CardUnit.Content>
                                                <StyledUnit.CardUnit.Content img={fetchStorageFerramentaVideo() + packageData.capaFilepath} />
                                            </StyledUnit.CardUnit.Container>
                                            <FVActionButtons
                                                onDelete={() => deletePackageUnit(unidade.id)}
                                                onEdit={() => handleEditForm(unidade)}
                                                msgDelete={`Tem certeza que deseja deletar esta ${
                                                    unidade?.nomenclature?.toString().toLowerCase() || 'unidade'
                                                }?`}
                                            />
                                            {!unidade?.description && (
                                                <StyledUnit.CardUnit.Description hovered={hoveredIndexCard === index} key={unidade.id}>
                                                    <h1
                                                        dangerouslySetInnerHTML={{
                                                            __html: formatTitleWithIndexSizeFontAll(unidade.title, index),
                                                        }}
                                                    />
                                                </StyledUnit.CardUnit.Description>
                                            )}
                                        </div>
                                        {unidade?.description?.length > 0 && (
                                            <StyledUnit.CardUnit.Information key={unidade.id}>
                                                <h2 dangerouslySetInnerHTML={{ __html: formatTitleWithPrefixIndex(unidade.title, index) }} />
                                                <h1>{unidade.title}</h1>
                                                <p dangerouslySetInnerHTML={{ __html: unidade.description }} />
                                            </StyledUnit.CardUnit.Information>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                    </Styled.Page.ContentGrid>
                </>
            )}
        </Styled.Page.Container>
    );
};

export default AdminFVPackage;
